import { render, staticRenderFns } from "./editBannerLocker.vue?vue&type=template&id=64fcba70&"
import script from "./editBannerLocker.vue?vue&type=script&lang=js&"
export * from "./editBannerLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports